<!--重点关注车辆-->
<template>
    <div>

        <div>

            <van-sticky><!-- 粘性布局，顶部的位置固定 -->
                <div class="conopen" style="background-color: #f8f8f9">

                    <van-row type="flex" justify="space-between">
                        <van-col span="3">
                            <div style="padding: 17px">
                                <van-icon name="arrow-left" size="15px" @click="onback"/><!-- icon图标，返回路劲 -->
                            </div>
                        </van-col>
                        <van-col span="18">
                            <!-- 搜索组件 -->
                            <form action="/">
                                <van-search
                                        style="width: 100%;"
                                        v-model="registrationNum"
                                        placeholder="车牌号\车架号"
                                        show-action
                                        @search="onFind"
                                >
                                    <div slot="action" @click="onFind">搜索</div>
                                </van-search>
                            </form>
                            <div v-if="false">
                                <DatePicker size="small" :placement="placement" type="date" placeholder="发生时间"
                                            v-model="dateFilter"
                                            style="width: 115px;padding: 5px;"></DatePicker>
                            </div>
                        </van-col>
                        <van-col span="3">
                            <div style="padding: 17px">
                                <!-- icon图标，刷新页面 -->
                                <van-icon name="replay" size="15px" @click="reststart"/>
                            </div>
                        </van-col>
                    </van-row>

                    <!-- 下拉菜单 -->
                    <van-dropdown-menu>
                        <van-dropdown-item v-model="value1" :options="option1" @change="check"/>
                    </van-dropdown-menu>

                </div>
            </van-sticky>
        </div>
        <div style="background-color: #f8f8f9">
            <van-pull-refresh v-model="isLoading" @refresh="refresh"><!-- 下拉刷新 -->
                <!-- 上拉加载 -->
                <van-list
                        v-model="loading"
                        :finished="finished"
                        finished-text="没有更多了"
                        @load="onLoad"
                >
                    <!-- 加载图标 -->
                    <van-loading class="loader" v-if="loader"/>
                    <div v-for="item in list" class="content">
                        <Card style="width:100%">
                            <Cell size="small" style="padding: 0px;">
                                <label size="small">车牌号：
                                    <label style="color: #0077aa;">{{item.vehicleInfo.registrationNum==null?item.vehicleInfo.vin:item.vehicleInfo.registrationNum}}</label>
                                </label>&nbsp;
                                <label size="small">主机号：
                                    <label style="color: #0077aa;">{{item.terminalNum}}</label>
                                </label>
                            </Cell>
                            <Cell size="small" style="padding: 0px;">
                                <label size="small">持续时长：<label style="color: #0077aa;">{{item.continueHours}}小时</label></label>&nbsp;
                                <label size="small">状态：<label style="color: red;">{{item.state===3?'报警':item.state===2?'离线':'未绑定终端'}}</label></label>
                            </Cell>
                            <Cell size="small" style="padding: 0px;">
                                <label size="small">是否恢复正常：<label
                                        style="color: #0077aa;">{{item.normal==true?'是':'否'}}</label></label>
                            </Cell>

                            <div class="mid">
                                <span class="count fl">定位时间:<label style="color: #0077aa;">{{new Date(item.locateDatetime).Format('yyyy年MM月dd日 hh:mm:ss')}}</label></span>
                            </div>
                            <div class="mid">
                                <span class="count fl">数据接收时间:<label style="color: #0077aa;">{{new Date(item.recvDatetime).Format('yyyy年MM月dd日 hh:mm:ss')}}</label></span>
                            </div>
                            <div class="mid">
                                <span class="count fl">分析时间:<label style="color: #0077aa;">{{new Date(item.analyzeDatetime).Format('yyyy年MM月dd日 hh:mm:ss')}}</label></span>
                            </div>
                            <div class="mid">
                                <span class="count fl">更新时间:<label style="color: #0077aa;">{{new Date(item.updateDatetime).Format('yyyy年MM月dd日 hh:mm:ss')}}</label></span>
                            </div>
                            <div class="mid">
                                <span class="count fl">创建时间:<label style="color: #0077aa;">{{new Date(item.createDatetime).Format('yyyy年MM月dd日 hh:mm:ss')}}</label></span>
                            </div>

                        </Card>
                        <div style="height: 3px"></div>
                        <!-- 分割线组件 -->
                        <!--            <van-divider :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0 16px' }">-->
                        <!--            </van-divider>-->
                    </div>
                </van-list>
            </van-pull-refresh>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import store from '@/store'
    import {genQueryParam, genSortParam} from '@/libs/queryparamhelper'
    import {
        Cell,
        CellGroup,
        Field,
        Row,
        Col,
        Button,
        Dialog,
        Radio,
        RadioGroup,
        Checkbox,
        CheckboxGroup,
        Picker,
        Popup,
        Divider,
        Collapse,
        CollapseItem,
        DatetimePicker,
        Tag,
        DropdownMenu,
        DropdownItem,
        Sticky,
        Icon,
        Search,
        PullRefresh,
        List,
        Loading,
        Toast,
    } from 'vant'


    Vue.use(Cell).use(CellGroup).use(Field).use(Row).use(Col).use(Button).use(Dialog).use(Radio).use(Tag).use(DropdownMenu).use(Toast)
        .use(RadioGroup).use(Checkbox).use(CheckboxGroup).use(Picker).use(Popup).use(Divider).use(Collapse).use(CollapseItem)
        .use(DatetimePicker).use(Icon).use(DropdownItem).use(Sticky).use(Search).use(PullRefresh).use(List).use(Loading);

    export default {
        name: "attentioncar",
        data() {
            return {
                value: '',
                list: [],
                registrationNum: '',
                dateFilter: '',
                value1: 0,
                option1: [
                    {text: '未恢复正常', value: 0},
                    {text: '已恢复正常', value: 1},
                ],
                placement: 'right-start',

                i: [],
                loading: false,
                finished: false,
                loader: false,
                isLoading: false,
            }
        },
        methods: {
            refresh() {
                // <!-- 下拉刷新方法 -->
                // if (this.value1 == 0) {
                //
                //     // 客户获取重点关注车辆分析分页
                //     var queryParams = [];
                //     queryParams.push(genQueryParam('normal', 'EQBOOL', false))
                //     store.dispatch('AttentionVehicleAnalysisServ_GetClientPage', {
                //         params: null,
                //         urlparams: {
                //             keyword: this.registrationNum,
                //             q: queryParams,
                //             sort: genSortParam('createDatetime', false)
                //         }
                //     }).then((res) => {
                //         console.log(res)
                //         this.list = res.data.content
                //         this.isLoading = false
                //     })
                //         .catch((err) => {
                //             console.log(err)
                //         })
                // } else if (this.value1 == 1) {
                //     // 客户获取重点关注车辆分析分页
                //     var queryParams = [];
                //     queryParams.push(genQueryParam('normal', 'EQBOOL', true))
                //     store.dispatch('AttentionVehicleAnalysisServ_GetClientPage', {
                //         params: null,
                //         urlparams: {
                //             keyword: this.registrationNum,
                //             q: queryParams,
                //             sort: genSortParam('createDatetime', false)
                //         }
                //     }).then((res) => {
                //         console.log(res)
                //         this.list = res.data.content
                //         this.isLoading = false
                //     })
                //         .catch((err) => {
                //             console.log(err)
                //         })
                // }
                setTimeout(()=>{
                    this.i=[]
                    this.list=[]
                    this.finished = false;
                    this.onLoad()
                    this.isLoading=false
                },500)
            },
            // <!-- icon图标刷新方法 -->
            reststart() {
                this.loader = true
                setTimeout(()=> {
                    this.i=[]
                    this.list=[]
                    this.finished = false;
                    this.onLoad()
                    // if (this.value1 == 0) {
                    //
                    //     // 客户获取重点关注车辆分析分页
                    //     var queryParams = [];
                    //     queryParams.push(genQueryParam('normal', 'EQBOOL', false))
                    //     store.dispatch('AttentionVehicleAnalysisServ_GetClientPage', {
                    //         params: null,
                    //         urlparams: {
                    //             keyword: this.registrationNum,
                    //             q: queryParams,
                    //             sort: genSortParam('createDatetime', false)
                    //         }
                    //     }).then((res) => {
                    //         console.log(res)
                    //         this.list = res.data.content
                    //         this.loader = false
                    //     })
                    //         .catch((err) => {
                    //             console.log(err)
                    //         })
                    // } else if (this.value1 == 1) {
                    //     // 客户获取重点关注车辆分析分页
                    //     var queryParams = [];
                    //     queryParams.push(genQueryParam('normal', 'EQBOOL', true))
                    //     store.dispatch('AttentionVehicleAnalysisServ_GetClientPage', {
                    //         params: null,
                    //         urlparams: {
                    //             keyword: this.registrationNum,
                    //             q: queryParams,
                    //             sort: genSortParam('createDatetime', false)
                    //         }
                    //     }).then((res) => {
                    //         console.log(res)
                    //         this.list = res.data.content
                    //         this.loader = false
                    //     })
                    //         .catch((err) => {
                    //             console.log(err)
                    //         })
                    // }
                    this.loader = false
                },500);
            },
            // <!-- 上拉加载方法 -->
            onLoad() {
                this.i.push(1)
                // this.list = []
                if (this.value1 == 0) {
                    // setTimeout(() => {

                        let bb
                        let qq = []
                        qq.push(genQueryParam('normal', 'EQBOOL', false))
                        //获取我的业务安装订单分页
                        store.dispatch('AttentionVehicleAnalysisServ_GetClientPage', {
                            params: null,
                            urlparams: {
                                q: qq,
                                keyword: this.registrationNum,
                                p: this.i.length,
                                sort: genSortParam('createDatetime', false)
                            }
                        }).then((res) => {
                            if (res.data.content.length != 0) {
                                console.log(res)
                                for (let j = 0; j < res.data.content.length; j++) {
                                    this.list.push(res.data.content[j]);
                                }
                                bb = res.data.totalElements
                                // this.installlist = res.data.content
                                // 加载状态结束
                                this.loading = false;

                                // 数据全部加载完成
                                if (this.list.length >= bb) {
                                    this.finished = true;
                                }
                            } else {
                                // 加载状态结束
                                this.loading = false;
                                this.finished = true;
                            }
                        })
                            .catch((err) => {
                                // 加载状态结束
                                this.loading = false;
                                this.finished = true;
                                Toast(err)
                                console.log(err)
                            })

                    // }, 500);
                } else if (this.value1 == 1) {
                    // setTimeout(() => {

                        let bb
                        let qq = []
                        qq.push(genQueryParam('normal', 'EQBOOL', true))
                        //获取我的业务安装订单分页
                        store.dispatch('AttentionVehicleAnalysisServ_GetClientPage', {
                            params: null,
                            urlparams: {
                                q: qq,
                                keyword: this.registrationNum,
                                p: this.i.length,
                                sort: genSortParam('createDatetime', false)
                            }
                        }).then((res) => {
                            console.log(res)
                            if (res.data.content.length != 0) {
                                for (let j = 0; j < res.data.content.length; j++) {
                                    this.list.push(res.data.content[j]);
                                }
                                bb = res.data.totalElements
                                // this.installlist = res.data.content
                                // 加载状态结束
                                this.loading = false;

                                // 数据全部加载完成
                                if (this.list.length >= bb) {
                                    this.finished = true;
                                }
                            } else {
                                // 加载状态结束
                                this.loading = false;
                                this.finished = true;
                            }
                        })
                            .catch((err) => {
                                // 加载状态结束
                                this.loading = false;
                                this.finished = true;
                                Toast(err)
                                console.log(err)
                            })

                    // }, 500);
                }

            },
            // <!-- icon返回路劲 -->
            onback() {
                this.$router.push({
                    name: 'myMenu'
                })
            },
            // <!-- 下拉菜单方法 -->
            check(e) {
                this.i=[]
                this.list=[]
                this.finished = false;
                this.onLoad()
                // console.log(e)
                // if (e === 0) {
                //     let qq = []
                //     qq.push(genQueryParam('normal', 'EQBOOL', false))
                //     // 客户获取重点关注车辆分析分页
                //     store.dispatch('AttentionVehicleAnalysisServ_GetClientPage', {
                //         params: null,
                //         urlparams: {
                //             keyword: this.registrationNum,
                //             q: qq,
                //             sort: genSortParam('createDatetime', false)
                //         }
                //     }).then((res) => {
                //         console.log(res)
                //         this.list = res.data.content
                //     })
                //         .catch((err) => {
                //             console.log(err)
                //         })
                // } else if (e === 1) {
                //     let qq = []
                //     qq.push(genQueryParam('normal', 'EQBOOL', true))
                //     // 客户获取重点关注车辆分析分页
                //     store.dispatch('AttentionVehicleAnalysisServ_GetClientPage', {
                //         params: null,
                //         urlparams: {
                //             keyword: this.registrationNum,
                //             q: qq,
                //             sort: genSortParam('createDatetime', false)
                //         }
                //     }).then((res) => {
                //         console.log(res)
                //         this.list = res.data.content
                //     })
                //         .catch((err) => {
                //             console.log(err)
                //         })
                // }
            },

            //搜索取消
            onCancel() {
                this.registrationNum = ''
                this.start()
            },
            // <!-- 搜索方法，默认normal为false，未恢复正常 -->
            onFind() {
                this.i=[]
                this.list=[]
                this.finished = false;
                this.onLoad()
                //
                // if (this.value1 == 0) {
                //
                //     // 客户获取重点关注车辆分析分页
                //     var queryParams = [];
                //     queryParams.push(genQueryParam('normal', 'EQBOOL', false))
                //     store.dispatch('AttentionVehicleAnalysisServ_GetClientPage', {
                //         params: null,
                //         urlparams: {
                //             keyword: this.registrationNum,
                //             q: queryParams,
                //             sort: genSortParam('createDatetime', false)
                //         }
                //     }).then((res) => {
                //         console.log(res)
                //         this.list = res.data.content
                //     })
                //         .catch((err) => {
                //             console.log(err)
                //         })
                // } else if (this.value1 == 1) {
                //     // 客户获取重点关注车辆分析分页
                //     var queryParams = [];
                //     queryParams.push(genQueryParam('normal', 'EQBOOL', true))
                //     store.dispatch('AttentionVehicleAnalysisServ_GetClientPage', {
                //         params: null,
                //         urlparams: {
                //             keyword: this.registrationNum,
                //             q: queryParams,
                //             sort: genSortParam('createDatetime', false)
                //         }
                //     }).then((res) => {
                //         console.log(res)
                //         this.list = res.data.content
                //     })
                //         .catch((err) => {
                //             console.log(err)
                //         })
                // }


            }
        },
        mounted() {
            this.$nextTick(() => {
                // let qq=[]
                // qq.push(genQueryParam('normal','EQBOOL',false))
                // // 客户获取重点关注车辆分析分页
                // store.dispatch('AttentionVehicleAnalysisServ_GetClientPage', {
                //     params: null,
                //     urlparams:{
                //         q:qq
                //     }
                // }).then((res) => {
                //     console.log(res)
                //     this.list = res.data.content
                // })
                //     .catch((err) => {
                //         console.log(err)
                //     })


            })
        }
    }
</script>

<style scoped>
    /*右侧内容*/
    .content {
        /*background-color: red;*/
        flex: 1;
        display: flex;
        flex-direction: column;
        padding: 0 15px 0 10px;
    }

    .content .name {
        font-size: 17px;
        color: #333;
        overflow: hidden;
        font-weight: bold;
        overflow: hidden;
    }

    /*月售、送达时间、距离*/
    .content .mid {
        flex: 1;
        margin-top: 7px;
        color: #666;
        font-size: 12px;
    }

    .next .next1 .next2 {
        flex: 1;
        margin-top: 0px;
        color: #666;
        font-size: 12px;
    }

    .conopen {
        text-align: right;
    }

    .loader {
        text-align: center;
    }

    .wrapper {
        width: 100%;
        height: 80%;
        position: absolute;
        top: 115px;
        bottom: 50px; /*关键*/
        overflow: hidden;
        z-index: 1;
    }
</style>
